import { RootState } from "../../store";

export const selectAssign = (state: RootState) => state.assign;